









































import Vue from 'vue'
import config from '@/utils/config'
import CimissDataService from '@/service/CimissDataService'
import warningImg from '@/utils/warningImg'
import moment from 'moment'
import sha1 from 'sha1'
import { WECHAT_APPID, WECAHT_NAME, IMG_URL } from '@/utils/constants'
import { wxShare } from '@/utils/wxApi'
import request from '@/utils/request'
export default Vue.extend({
  created() {
    //@ts-ignore
    this.warnId = this.$route.query.id
  },
  data() {
    return {
      warnId: "" as string,
      type: "" as string,
      warnInfo: undefined as any,
      loading: true,
    }
  },

  methods: {
    getWarnSingle() {
      const adminCode = config.defaultStationObj.adminCode
      let warnList: any[] = []
      const that = this
      CimissDataService.warningSignalList(adminCode).then((res: any) => {
        if (res && res.length > 0) {
          const alarms = res
          warnList = alarms.filter((e: any) => {
            e.imgUrl = warningImg.getImgSrc(`${e.typename}${e.level}`)
            e.fyzn = warningImg.getFyzn(`${e.typename}${e.level}`)
            e.background = warningImg.getWarnImgAndColor(`${e.typename}${e.level}`).background;
            e.color = warningImg.getWarnImgAndColor(`${e.typename}${e.level}`).color;
            e.publish_time = this.dateStr(e.datetime, '')
            const early_content = e.issuecontent
            const contentStr = early_content.split('：')
            if (contentStr.length > 1) {
              e.early_content = contentStr[1]
            }
            return e
          })

          for (let getWarnInfo of warnList) {
            const early_id = getWarnInfo.early_id
            if (early_id === that.warnId) {
              that.warnInfo = getWarnInfo

            }
          }
        }
        this.initWeixin()
        that.loading = false
      });

    },


    getWarninfoData() {
      const params = {
        areaCode: config.defaultStationObj.adminCode + '000000',
        startTime: moment().add(-60, 'h').format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      }
      let warnList: any[] = []
      request.get('/warninfo/getEarlyWarnHisInfo', params).then(res => {

        if (res && res.result) {
          const alarms = res.result.alarms
          warnList = alarms.filter((e: any) => {
            e.imgUrl = warningImg.getImgSrc(`${e.typename}${e.level}`)
            e.fyzn = warningImg.getFyzn(`${e.typename}${e.level}`)
            e.publish_time = this.dateStr(e.pubdate, '')

            return e
          })


        }
      });
    },

    async initWeixin() {

      let desc = ''
      if (this.type === '0') {
        desc = this.warnInfo.early_type + '预警信号'
      } 
      const url = window.location.href
      const timestamp = moment().valueOf()
      const nonceStr = 'tongzhouwechat'
      const jsapiTicket = await request.get('/api/account/office_account/jsapi_ticket')
      console.log('jsapiTicket', jsapiTicket)
      const params = `jsapi_ticket=${jsapiTicket}&noncestr=${nonceStr}&timestamp=${timestamp}&url=${url}`
      console.log('params', params)
      const signature = sha1(params)
      const obj = {
        appId: WECHAT_APPID,
        nonceStr: nonceStr,
        signature: signature,
        timestamp: timestamp,
      }

      let shareData = {
        title: WECAHT_NAME,
        desc: desc,
        imgUrl: IMG_URL,
        link: url,
      };
      wxShare(obj, shareData);
    },


    dateStr(dateStr: string, formater: string) {
      if (formater === '') {
        formater = '$1-$2-$3 $4:$5:$6'
      }
      let pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
      //将时间格式化成 yyyy-MM-dd HH:mm:ss
      let formatDateStr = dateStr.toString().replace(pattern, formater);
      return formatDateStr;
    }
  }
})
